import axios from 'axios';
import { V1API } from '../../../_helpers/APIPath';
import { encode, decode } from '../../dataMagic';
import { populateStore, performNetworkCall, buildFormData } from '@/store/asyncHelper';



const mutations = {};
const store = {};

populateStore(store, mutations, false);

export default {
    namespaced: true,

    state : {
        spotons: [],
        spotonLoading: false,
        spotonError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_SPOTON (state, items) {
            state.spotons = items;
        },

        SPOTON_LOADING (state, loading) {
            state.spotonLoading = loading;
        },

        SPOTON_ERROR (state, hasError) {
            state.spotonError = hasError;
        }
    },

    actions: {
        async fetchSpotOnList ({ commit }) {
            commit('SPOTON_LOADING', true);
            commit('SPOTON_ERROR', false);

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };

            try{
                let result = await axios.get(V1API.spoton_list, config);
                let response = result.data;

                commit('SET_SPOTON', response.data);

            } catch(error) {
                commit('SPOTON_ERROR', true);
            } finally {
                commit('SPOTON_LOADING', false);
            }
        },

        async deleteSpotOn({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.spoton_delete + payload.delete_value, config).then(result=>{
                let data = result.data
                return data
            })

            dispatch ('fetchSpotOnList')
            return response
        },

        async updateStatusToggle({ commit, dispatch }, payload) {
            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };
            console.log(payload.delete);
            let response = await axios.get(V1API.spoton_status_toggle + payload.spoton_id, config).then(result=>{
                let data = result.data;
                return data;
            });

            dispatch ('fetchSpotOnList');

            return response;
        }
    },

    getters: {}
};
